/* global document */
/* global store */
/* global IS_PREVIEW_PAGE */

import { initialiseAnimation } from 'Render/utils/importers';
import { handleKeyFrameActions } from 'Renderer/domOperations/actionOperations';
import { gsap } from 'gsap';

const getGroupChildren = group => [...group.firstChild.querySelectorAll('*')].map(elem => elem.id);

export const setTargetComponentTimeline = (component, artboard = null, wrapper = null) => {
  const { activeArtboard, adNameSpace, artboards } = store.getState(); // eslint-disable-line no-undef

  const componentArtboard = artboard ? artboards.find(itm => itm.name === artboard) : null;
  const targetComponentArtboard = componentArtboard || activeArtboard;

  if (!component) return null;

  const componentId = component.id;
  const wrapperWIndow = wrapper ? wrapper.ownerDocument.defaultView : window; // eslint-disable-line no-undef
  const rootWindow = IS_PREVIEW_PAGE ? wrapperWIndow : window; // eslint-disable-line no-undef

  const targetComponentTimelines = rootWindow[adNameSpace].targetComponentTimelines;
  if (!targetComponentTimelines[targetComponentArtboard.key]) targetComponentTimelines[targetComponentArtboard.key] = {};

  const activeArtboardComponentTimelines = targetComponentTimelines[targetComponentArtboard.key];
  if (activeArtboardComponentTimelines[componentId]) {
    activeArtboardComponentTimelines[componentId].kill();
    delete rootWindow[adNameSpace].targetComponentTimelines[targetComponentArtboard.key][componentId];
  }

  const childElements = getGroupChildren(component);
  const filteredGSAP = targetComponentArtboard.gsap.filter(itm => childElements.includes(itm.target));
  if (filteredGSAP.length === 0) return null;

  const dataLoop = component.getAttribute('data-loop') || 0;
  const animationLoop = (dataLoop > 0) ? dataLoop - 1 : dataLoop;

  activeArtboardComponentTimelines[componentId] = new gsap.timeline({ paused: true, repeat: animationLoop, repeatRefresh: true });
  initialiseAnimation(activeArtboardComponentTimelines[componentId], filteredGSAP, handleKeyFrameActions);
  targetComponentTimelines[targetComponentArtboard.key] = activeArtboardComponentTimelines;
  rootWindow[adNameSpace].targetComponentTimelines = targetComponentTimelines;

  return activeArtboardComponentTimelines[componentId];
};

export const initialiseComponentTimelines = (artboard = null) => {
  const { adNameSpace, rootElement } = store.getState(); // eslint-disable-line no-undef
  const rootWindow = frameElement ? frameElement.contentWindow : window; // eslint-disable-line no-undef
  if (!rootWindow[adNameSpace]) rootWindow[adNameSpace] = {};
  if (!rootWindow[adNameSpace].targetComponentTimelines || IS_PREVIEW_PAGE) rootWindow[adNameSpace].targetComponentTimelines = {};
  if (artboard) rootWindow[adNameSpace].targetComponentTimelines[artboard.key] = {};
  const groupElements = rootElement.querySelectorAll('div[data-group]');
  [...groupElements].forEach(elem => setTargetComponentTimeline(elem));
};

export const getFilteredArtboardTimeline = (artboard) => {
  const { rootElement } = store.getState(); // eslint-disable-line no-undef

  let filteredGSAP = artboard.gsap;

  const groupElements = rootElement.querySelectorAll('div[data-group]');
  [...groupElements].forEach((group) => {
    const childElements = getGroupChildren(group);
    filteredGSAP = filteredGSAP.filter(itm => !childElements.includes(itm.target));
  });

  return filteredGSAP;
};



// WEBPACK FOOTER //
// ./app/javascript/renderer/domOperations/animationOperations.js